import * as React from "react";
import { formatRelative } from "date-fns";
import { sv, enUS, de, nb, nn } from "date-fns/locale";
import i18next from "i18next";
export var FormattedDateTime = function (props) {
    return React.createElement(React.Fragment, null, formatDate(props.date, props.relative));
};
export function formatDate(dateOrString, relative) {
    var ln = i18next.resolvedLanguage;
    var languageAndLocale = {
        "en": enUS,
        "sv": sv,
        "de": de,
        "nb": nb,
        "nn": nn
    };
    // HACK since apollo client does not support custom scalars the date here may in-fact be a string (looks like v3 may support custom scalars )
    var date = typeof dateOrString === "string" ? new Date(dateOrString) : dateOrString;
    return date
        ? !relative
            ? date.toLocaleDateString() +
                " " +
                date.toLocaleTimeString(undefined, {
                    hour: "2-digit",
                    minute: "2-digit",
                })
            : formatRelative(date, new Date(), { locale: languageAndLocale[ln] })
        : "";
}
//# sourceMappingURL=FormattedDateTime.js.map